
<div class="row noselect">
  <div class="icon">
    <mat-icon>{{icon}}</mat-icon>
    <div
      *ngIf="onlineStatus != getOnlineStatus().NONE"
      [class.online]="onlineStatus == getOnlineStatus().ONLINE"
      [class.offline]="onlineStatus == getOnlineStatus().OFFLINE"
    ></div>
  </div>
  <div class="column">
    <h3 class="title">{{title}}</h3>
    <span class="subtitle">{{subtitle}}</span>
    <div class="chips">
      <span *ngFor="let chip of chips" [ngStyle]="{background: chip.color}" class="narrow">{{chip.text}}</span>
    </div>
  </div>
  <div class="more">{{ 'More details' | translate }} <mat-icon>keyboard_arrow_right</mat-icon></div>
</div>
